import { handleResponse } from "../_helpers/handle-response";
import { authHeader } from "../_helpers/auth-header.js";
import { BASE_URL } from "../_constants/services.constants.js";

const userService = {
  getAll,
  register,
  update,
  delete: _delete,
  changePassword,
};

function getAll() {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(`${BASE_URL}/User/GetUserList`, requestOptions).then(
    handleResponse,
  );
}

function register(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData,
  };

  return fetch(`${BASE_URL}/User/AddUser`, requestOptions).then(handleResponse);
}

function update(formData) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: formData,
  };

  return fetch(`${BASE_URL}/User/UpdateUser`, requestOptions).then(
    handleResponse,
  );
}

function _delete(formData) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    body: formData,
  };

  return fetch(`${BASE_URL}/User/DeleteUser`, requestOptions).then(
    handleResponse,
  );
}

function changePassword(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData,
  };

  return fetch(`${BASE_URL}/User/ChanagePassword`, requestOptions).then(
    handleResponse,
  );
}

export default userService;
